import { createSliceSelectors } from '../utils'

const RoutingSelectors = createSliceSelectors('routing', [
    {
        namespace: 'pathname',
        selectorIn: location => location.pathname,
    },

    {
        namespace: 'search',
        selectorIn: location => location.search,
    },

    {
        namespace: 'query',
        selectorIn: location => location.query,
    },
])

export default RoutingSelectors
